import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import LeftNav from '../common/LeftNav';
import TopNav from '../common/TopNav';
import adminCrmService from '../../../services/adminCrmService';
import { FaChevronRight } from 'react-icons/fa';
import '../../../assets/styles/PersonalIDs.css';
import '../../assets/styles/CRMOpenLead.css';
import arrowleftt from '../../assets/img/arrowleftt.svg';
import { toast } from 'react-toastify';

const ROLE_COLORS = {
  agent: '#7C3AED',
  agency: '#2563EB',
  builder: '#D97706',
};

const getMenuItems = (role) => {
  const common = {
    billing:        { key: 'billing',        label: 'Billing Summary',      icon: '🧾', path: '/AdminCrmBillingSummary' },
    personal:       { key: 'personal',       label: 'Personal Information', icon: '👤', path: '/AdminCrmPersonalInfo' },
    builderInfo:    { key: 'builderInfo',    label: 'Builder Information',  icon: '🏢', path: '/AdminCrmPersonalInfo' },
    professionalIds:{ key: 'professionalIds',label: 'Professional IDs',     icon: '🪪', path: '/AdminCrmProfessionalIds' },
    ratingsReviews:    { key: 'ratingsReviews',    label: 'Ratings & Reviews',      icon: '⭐', path: '/AdminCrmReviews' },
    manageProjects:    { key: 'manageProjects',    label: 'Manage Projects',        icon: '🏠', path: '/AdminCrmManageProjects' },
    mandateProjects:   { key: 'mandateProjects',   label: 'Mandate Projects',       icon: '📄', path: '/AdminCrmMandateProjects' },
    addListing:        { key: 'addListing',        label: 'Add Listing',            icon: '🏠', path: '/AdminCrmListings' },
    staffActivityLogs: { key: 'staffActivityLogs', label: 'Staff Activity Logs',    icon: '🕐', path: '/AdminCrmStaffActivityLogs' },
  };
  switch (role) {
    case 'builder': return [common.billing, common.manageProjects, common.mandateProjects, common.builderInfo, common.professionalIds, common.ratingsReviews, common.staffActivityLogs];
    case 'agent':   return [common.billing, common.addListing, common.personal, common.professionalIds, common.ratingsReviews, common.staffActivityLogs];
    case 'agency':  return [common.billing, common.addListing, common.personal, common.professionalIds, common.ratingsReviews, common.staffActivityLogs];
    default:        return [common.billing, common.personal, common.professionalIds, common.staffActivityLogs];
  }
};

const MENU_ICONS = {
  billing:         <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/></svg>,
  personal:        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>,
  builderInfo:     <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2"/><line x1="12" y1="12" x2="12" y2="16"/><line x1="10" y1="14" x2="14" y2="14"/></svg>,
  professionalIds: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="5" width="20" height="14" rx="2"/><line x1="2" y1="10" x2="22" y2="10"/></svg>,
  ratingsReviews:  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>,
  manageProjects:  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>,
  addListing:      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>,
  mandateProjects: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><polyline points="9 15 11 17 15 13"/></svg>,
  staffActivityLogs:<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>,
};

const formatDate = (d) => {
  if (!d) return 'N/A';
  return new Date(d).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' });
};

const formatCurrency = (amount) =>
  new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 }).format(amount || 0);

const MODAL_BTN_STYLE = {
  flex: 1, height: '44px', padding: '0 12px',
  display: 'flex', alignItems: 'center', justifyContent: 'center',
  border: 'none', borderRadius: '10px',
  fontSize: '15px', fontWeight: '600', lineHeight: 1, cursor: 'pointer',
};

// Confirmation popup for account actions; shows a required reason box when reasonLabel is set
function ConfirmModal({ icon, iconBg, title, message, reasonLabel, reason, onReasonChange, confirmLabel, confirmColor, onCancel, onConfirm }) {
  return (
    <div
      onClick={onCancel}
      style={{
        position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.5)',
        // Above the sidebar (LeftNav z-index 1040) so it's dimmed too
        display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1055, padding: '24px'
      }}
    >
      <div className="card p-4" onClick={e => e.stopPropagation()} style={{ maxWidth: '400px', width: '100%', borderRadius: '20px', textAlign: 'center' }}>
        <div style={{
          width: '68px', height: '68px', borderRadius: '50%', backgroundColor: iconBg,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          margin: '0 auto 16px', fontSize: '32px'
        }}>{icon}</div>
        <h6 className="accordion-title mb-2" style={{ fontSize: '17px' }}>{title}</h6>
        <p style={{ fontSize: '14px', color: '#6B7280', lineHeight: '1.6', marginBottom: reasonLabel ? '16px' : '24px' }}>{message}</p>
        {reasonLabel && (
          <textarea
            className="form-control mb-4"
            rows={4}
            autoFocus
            placeholder={`Enter reason for ${reasonLabel} this account`}
            value={reason}
            onChange={(e) => onReasonChange(e.target.value)}
            style={{ fontSize: '14px', borderRadius: '10px', resize: 'none' }}
          />
        )}
        <div className="d-flex gap-3">
          <button onClick={onCancel} style={{ ...MODAL_BTN_STYLE, backgroundColor: '#F3F4F6', color: '#374151' }}>Cancel</button>
          <button onClick={onConfirm} style={{ ...MODAL_BTN_STYLE, backgroundColor: confirmColor, color: '#fff' }}>{confirmLabel}</button>
        </div>
      </div>
    </div>
  );
}

export default function AdminCrmUserMenu() {
  const navigate = useNavigate();
  const location = useLocation();
  const { userId, userName, userRole, userEmail, userPhone } = location.state || {};

  const [membershipData, setMembershipData] = useState(null);
  const [membershipLoading, setMembershipLoading] = useState(true);
  const [userStatus, setUserStatus] = useState('active');
  const [actionLoading, setActionLoading] = useState(false);
  // Only one confirmation popup can be open: 'disable' | 'enable' | 'delete' | null
  const [confirmAction, setConfirmAction] = useState(null);
  const [reason, setReason] = useState('');

  useEffect(() => {
    if (userId) {
      fetchMembership();
      loadUserStatus();
    }
  }, [userId]);

  const fetchMembership = async () => {
    try {
      const res = await adminCrmService.getUserMembership(userId);
      if (res.success) setMembershipData(res.data);
    } catch (err) {
      console.error('Fetch membership error:', err);
    } finally {
      setMembershipLoading(false);
    }
  };

  const loadUserStatus = async () => {
    try {
      const response = await adminCrmService.getUserStatus(userId);
      if (response?.success && response?.data?.status) setUserStatus(response.data.status);
      else if (response?.data?.data?.status) setUserStatus(response.data.data.status);
    } catch (e) {
      console.error('Error loading user status:', e);
    }
  };

  const openConfirm = (action) => { setReason(''); setConfirmAction(action); };

  // Confirmation popups (disable/delete require a reason) - matching mobile app
  const name = userName || 'this user';
  const ACTIONS = {
    disable: {
      icon: '🚫', iconBg: '#FFFBEB', title: 'Disable Account?', confirmLabel: 'Disable', confirmColor: '#F59E0B',
      message: <><strong>{userName || 'This user'}</strong> will not be able to login until you re-enable the account. An email notification will be sent to them with the reason below.</>,
      reasonLabel: 'disabling',
      run: (r) => adminCrmService.disableUser(userId, r),
      onSuccess: () => { setUserStatus('disabled'); toast.success('Account disabled successfully.'); },
      failMessage: 'Failed to disable user.',
    },
    enable: {
      icon: '✅', iconBg: '#ECFDF5', title: 'Enable Account?', confirmLabel: 'Enable', confirmColor: '#10B981',
      message: <>Are you sure you want to re-enable <strong>{name}</strong>'s account? They will be able to login again.</>,
      run: () => adminCrmService.enableUser(userId),
      onSuccess: () => { setUserStatus('active'); toast.success('Account enabled successfully.'); },
      failMessage: 'Failed to enable user.',
    },
    delete: {
      icon: '⚠️', iconBg: '#FEF2F2', title: 'Permanently Delete User?', confirmLabel: 'Delete Forever', confirmColor: '#DC2626',
      message: <>This will permanently delete <strong>{name}</strong>'s account and all associated data
        including leads, properties, subscriptions, and billing records.
        <br /><br />This action <strong>cannot be undone</strong>. An email notification will be sent to the user with the reason below.</>,
      reasonLabel: 'deleting',
      run: (r) => adminCrmService.deleteUserPermanently(userId, r),
      onSuccess: () => { toast.success('User permanently deleted.'); navigate(-1); },
      failMessage: 'Failed to delete user.',
    },
  };

  const runConfirmedAction = async () => {
    const action = ACTIONS[confirmAction];
    const trimmed = reason.trim();
    if (action.reasonLabel && !trimmed) {
      toast.warning(`Reason Required: Please enter a reason for ${action.reasonLabel} this account.`);
      return;
    }
    setConfirmAction(null);
    setActionLoading(true);
    try {
      const r = await action.run(trimmed);
      if (r?.success || r?.data?.success) action.onSuccess();
      else toast.error(r?.message || r?.error || action.failMessage);
    } catch {
      toast.error('Something went wrong.');
    } finally {
      setActionLoading(false);
    }
  };

  const roleColor = ROLE_COLORS[userRole] || '#6B7280';
  const menuItems = getMenuItems(userRole);
  const initials = userName
    ? userName.trim().split(' ').length > 1
      ? (userName.trim().split(' ')[0][0] + userName.trim().split(' ').slice(-1)[0][0]).toUpperCase()
      : userName.substring(0, 2).toUpperCase()
    : 'U';

  const current = membershipData?.current_subscription;
  const progressPct = current?.duration_days && membershipData?.days_remaining
    ? Math.max(5, Math.min(100, ((current.duration_days - membershipData.days_remaining) / current.duration_days) * 100))
    : 0;

  return (
    <div className="d-flex" style={{ background: '#fff', minHeight: '100vh' }}>
      <LeftNav />
      <div className="main-content flex-grow-1">
        <TopNav />

        <div className="p-3">

          {/* Back + Title */}
          <div className="d-flex align-items-center gap-2 mb-3">
            <img src={arrowleftt} onClick={() => navigate(-1)} style={{ cursor: 'pointer' }} alt="back" />
            <h6 className="accordion-title mb-0">User Profile</h6>
          </div>

          {/* Profile Card */}
          <div className="accordion-item mb-3" style={{ borderRadius: '12px', overflow: 'hidden' }}>
            <div className="accordion-header d-flex align-items-center gap-3" style={{ cursor: 'default' }}>
              <div style={{
                width: '52px', height: '52px', borderRadius: '50%', flexShrink: 0,
                backgroundColor: roleColor + '20',
                display: 'flex', alignItems: 'center', justifyContent: 'center'
              }}>
                <span style={{ fontSize: '18px', fontWeight: '700', color: roleColor }}>{initials}</span>
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <h6 className="accordion-title mb-1" style={{ fontSize: '16px' }}>{userName || 'Unknown'}</h6>
                <div className="d-flex align-items-center gap-2 flex-wrap">
                  <span style={{
                    backgroundColor: roleColor + '20', color: roleColor,
                    padding: '2px 10px', borderRadius: '6px', fontSize: '11px', fontWeight: '600', textTransform: 'capitalize'
                  }}>
                    {userRole?.charAt(0).toUpperCase() + userRole?.slice(1)}
                  </span>
                  <span style={{ fontSize: '12px', color: '#6B7280' }}>{userEmail}</span>
                </div>
                {userPhone && <div style={{ fontSize: '12px', color: '#9CA3AF', marginTop: '2px' }}>{userPhone}</div>}
              </div>
              {userStatus === 'disabled' && (
                <span style={{
                  backgroundColor: '#FEF2F2', color: '#DC2626',
                  padding: '3px 10px', borderRadius: '8px', fontSize: '11px', fontWeight: '600', flexShrink: 0
                }}>Disabled</span>
              )}
            </div>
          </div>

          {/* Membership */}
          <div className="accordion-item mb-3">
            <div className="accordion-header">
              <h6 className="accordion-title mb-0">Membership</h6>
            </div>
            <div className="accordion-body">
              {membershipLoading ? (
                <div className="text-center py-3" style={{ color: '#059669' }}>Loading membership...</div>
              ) : membershipData && current ? (
                <div className="card p-4 personal-ids-card">
                  <div className="d-flex align-items-center justify-content-between mb-3">
                    <div>
                      <div style={{ fontSize: '17px', fontWeight: '700', color: '#111827' }}>{current.plan_name || 'No Plan'}</div>
                      <div style={{ fontSize: '13px', fontWeight: '600', color: membershipData.is_active ? '#059669' : '#DC2626', marginTop: '2px' }}>
                        {membershipData.is_active ? '● Active' : '● Inactive'}
                      </div>
                    </div>
                    {membershipData.is_active && (
                      <div style={{
                        border: '1px solid #BBF7D0', borderRadius: '10px',
                        padding: '10px 14px', textAlign: 'center', background: '#F0FDF4'
                      }}>
                        <div style={{ fontSize: '22px', fontWeight: '800', color: '#059669' }}>{membershipData.days_remaining}</div>
                        <div style={{ fontSize: '10px', color: '#6B7280' }}>days left</div>
                      </div>
                    )}
                  </div>

                  {membershipData.is_active && current.current_period_start && (
                    <div className="mb-3">
                      <div style={{ height: '6px', backgroundColor: '#E5E7EB', borderRadius: '3px', overflow: 'hidden', marginBottom: '4px' }}>
                        <div style={{ height: '100%', width: `${progressPct}%`, backgroundColor: '#059669', borderRadius: '3px' }} />
                      </div>
                      <div className="d-flex justify-content-between">
                        <span style={{ fontSize: '10px', color: '#9CA3AF' }}>{formatDate(current.current_period_start)}</span>
                        <span style={{ fontSize: '10px', color: '#9CA3AF' }}>{formatDate(current.current_period_end)}</span>
                      </div>
                    </div>
                  )}

                  <div className="d-flex justify-content-between py-2" style={{ borderTop: '1px solid #F3F4F6' }}>
                    <span className="personal-label">Price</span>
                    <span style={{ fontWeight: '600', fontSize: '13px' }}>{formatCurrency(current.offer_price || current.price)}</span>
                  </div>
                  <div className="d-flex justify-content-between py-2" style={{ borderTop: '1px solid #F3F4F6' }}>
                    <span className="personal-label">Duration</span>
                    <span style={{ fontWeight: '600', fontSize: '13px' }}>{current.duration_days || 'N/A'} days</span>
                  </div>
                </div>
              ) : (
                <div className="card p-4 personal-ids-card text-center" style={{ color: '#9CA3AF' }}>
                  No active membership
                </div>
              )}
            </div>
          </div>

          {/* Profile Menu */}
          <div className="accordion-item mb-3">
            <div className="accordion-header">
              <h6 className="accordion-title mb-0">Profile Menu</h6>
            </div>
            <div className="accordion-body" style={{ padding: 0 }}>
              <div style={{ overflow: 'hidden' }}>
                {menuItems.map((item, index) => (
                  <div
                    key={item.key}
                    className="d-flex align-items-center justify-content-between px-4 py-3"
                    onClick={() => navigate(item.path, { state: { userId, userName, userRole, userEmail, userPhone } })}
                    style={{
                      cursor: 'pointer',
                      borderBottom: index < menuItems.length - 1 ? '1px solid #F3F4F6' : 'none',
                      transition: 'background 0.15s'
                    }}
                    onMouseEnter={e => e.currentTarget.style.backgroundColor = '#F9FAFB'}
                    onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'}
                  >
                    <div className="d-flex align-items-center gap-3">
                      <span style={{ display: 'flex', alignItems: 'center' }}>{MENU_ICONS[item.key]}</span>
                      <span style={{ fontSize: '15px', fontWeight: '500', color: '#111827' }}>{item.label}</span>
                    </div>
                    <FaChevronRight size={14} color="#9CA3AF" />
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Account Actions */}
          <div className="accordion-item mb-3">
            <div className="accordion-header">
              <h6 className="accordion-title mb-0">Account Actions</h6>
            </div>
            <div className="accordion-body">
              <div style={{ padding: '4px 0' }}>
                {userStatus === 'disabled' && (
                  <div className="d-flex align-items-center gap-2 mb-3 p-2" style={{ backgroundColor: '#FEF2F2', borderRadius: '8px' }}>
                    <span>ℹ️</span>
                    <span style={{ fontSize: '12px', color: '#DC2626' }}>Account is currently disabled. User cannot login.</span>
                  </div>
                )}

                <div className="d-flex gap-3">
                  {userStatus === 'disabled' ? (
                    <button
                      onClick={() => openConfirm('enable')}
                      disabled={actionLoading}
                      className="personal-uspbtn d-flex justify-content-center align-items-center gap-2 flex-grow-1"
                      style={{ backgroundColor: '#10B981', border: 'none', borderRadius: '10px', padding: '12px' }}
                    >
                      <span className="personal-uspbtntext">{actionLoading ? 'Processing...' : <><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: 6 }}><polyline points="20 6 9 17 4 12"/></svg>Enable Account</>}</span>
                    </button>
                  ) : (
                    <button
                      onClick={() => openConfirm('disable')}
                      disabled={actionLoading}
                      className="personal-uspbtn d-flex justify-content-center align-items-center gap-2 flex-grow-1"
                      style={{ backgroundColor: '#F59E0B', border: 'none', borderRadius: '10px', padding: '12px' }}
                    >
                      <span className="personal-uspbtntext">{actionLoading ? 'Processing...' : <><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" style={{ marginRight: 6 }}><circle cx="12" cy="12" r="10"/><line x1="4.93" y1="4.93" x2="19.07" y2="19.07"/></svg>Disable Account</>}</span>
                    </button>
                  )}

                  <button
                    onClick={() => openConfirm('delete')}
                    disabled={actionLoading}
                    className="personal-uspbtn d-flex justify-content-center align-items-center gap-2 flex-grow-1"
                    style={{ backgroundColor: '#DC2626', border: 'none', borderRadius: '10px', padding: '12px' }}
                  >
                    <span className="personal-uspbtntext">{actionLoading ? 'Processing...' : <><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: 6 }}><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6M14 11v6"/><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>Delete User</>}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      {confirmAction && (
        <ConfirmModal
          {...ACTIONS[confirmAction]}
          reason={reason}
          onReasonChange={setReason}
          onCancel={() => setConfirmAction(null)}
          onConfirm={runConfirmedAction}
        />
      )}
    </div>
  );
}
